<div class="content-wrapper-col2-vf">
    <div>
        <div class="col-wrap-v">
            <app-place-editor-page-fields 
                [data]="data" (onCompleted)="onPlaceEditorCompleted($event)"
                (onCancel)="onPlaceEditCancelled()"
                class="editor-panel"></app-place-editor-page-fields>
        </div>
        <div class="col-wrap-f">
            <app-place-editor-page-list #placeListRef 
                [placeList]="data" [selectedPlaceId]="highlightedPlaceId"
                (onCompleted)="onPlaceListCompleted($event)" (onCancel)="onPlaceEditCancelled()"
                class="list-panel">
            </app-place-editor-page-list>

        </div>
    </div>
</div>